import subContext from './sub-context.js'
import itemEmpty from './item-empty.js'
import buildReferences from './referenced-properties.js'

/**
 *
 * @param {ModuleBuilderContext} context
 * @param {boolean} recurse
 *
 * @return {object}
 */
export default function moduleShow (context, recurse = true) {
  const {resource, $name, $namespace, $parentNamespace} = context;
  const uc = resource.name.toUpperCase();
  const RESET = uc + '_SHOW_RESET'
  const SET_ERROR = uc + '_SHOW_SET_ERROR'
  const SET_RETRIEVED = uc + '_SHOW_SET_RETRIEVED'
  const TOGGLE_LOADING = uc + '_SHOW_TOGGLE_LOADING'

  const modules = {}
  if (!resource.operations.show) {
    console.log(resource)
    throw new Error('Logic exception? Resource has no show URL: ' + resource.name)
  }
  if (recurse) {
    const references = buildReferences(subContext(context, 'references'), resource.operations.show.output.properties)
    if (references !== undefined) {
      modules.references = references
    }
  }

  return {
    namespaced: true,
    modules: {
      ...modules
    },
    state: {
      $name,
      $namespace,
      $parentNamespace,
      error: '',
      isLoading: false,
      item: itemEmpty(resource.operations.show.output.properties)
    },
    actions: {
      retrieve: ({ commit, dispatch }, id) => {
        commit(TOGGLE_LOADING)

        return dispatch('api/fetch', {uri: id}, { root: true })
          .then(response => response.json())
          .then((data) => {
            commit(TOGGLE_LOADING)
            commit(SET_RETRIEVED, data)
            if (recurse) {
              dispatch('references/loadFor', data)
            }
          })
          .catch((e) => {
            commit(TOGGLE_LOADING)
            commit(SET_ERROR, e.message)
          })
      },
      reset: ({ commit, dispatch }) => {
        commit(RESET)
        if (recurse) {
          dispatch('references/reset')
        }
      }
    },
    getters: {
      error: state => state.error,
      isLoading: state => state.isLoading,
      item: state => state.item
    },
    mutations: {
      [RESET] (state) {
        Object.assign(state, {
          error: '',
          isLoading: false,
          item: itemEmpty(resource.operations.show.output.properties)
        })
      },
      [SET_ERROR] (state, error) {
        Object.assign(state, { error })
      },
      [SET_RETRIEVED] (state, item) {
        Object.assign(state, { item })
      },
      [TOGGLE_LOADING] (state) {
        Object.assign(state, { isLoading: !state.isLoading })
      }
    }
  }
}
